import "./footer.css";
import { Link } from "react-router-dom";

const footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <p>
              Copyright &copy; 2036{" "}
              <Link to="/#" className="link">
                Cyborg Gaming
              </Link>{" "}
              Company. All rights reserved. <br />
              Designed by:{" "}
              <Link to="/#" className="link">
                Hussam Odeh
              </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default footer;
